import React, { Component } from "react";
import Registry from "../../../Utils/Registry";

import TYItem from "../../TYItem";
import { NotificationManager } from "react-notifications";
import Variables from "../../../Utils/Variables";


class OperationsRecurrentDetailsContact extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.state = {
        };
    }
    
    removeContact = () => {
        this.api.del(`/recurrent/${this.props.recId}/contact/${this.props.data.id}/detach`)
            .then(_ => {
                NotificationManager.success("Contact supprimé de la recurrence");
                if(this.props.onUpdate)
                    this.props.onUpdate();
            })
            .catch(_ => {
                NotificationManager.error("Impossible de supprimer le contact de la recurrence");
            });
    };

    setAsPrincipal = () => {
        this.api.put(`/recurrent/${this.props.recId}/contact/${this.props.data.id}`, {is_master_contact: true})
            .then(_ => {
                NotificationManager.success("Contact mis à jour");
                if(this.props.onUpdate)
                    this.props.onUpdate();
            })
            .catch(_ => {
                NotificationManager.error("Impossible de mettre à jour le contact");
            });
    };

    render(){
        const {name, role, type, phone_number, email, is_master_contact} = this.props.data
        const hasType = Variables.businessContactTypes.find(b => b.id === type)
        let actions = [];
        if(!is_master_contact)
            actions.push({ label: "Indiquer comme contact principal", onclick: this.setAsPrincipal });
        actions.push({ label: "Supprimer", onclick: this.removeContact });

        return <div className="ty-list-item marg-b-5">
            <TYItem
                icon="icon icon-account icon-2x"
                actions={actions}
                flagColorCode={ is_master_contact ? "#e67e22" : undefined }
            >
                <div><span className="bold">{ name }</span> ({ role })</div>
                {hasType ? hasType.value : ""}
                <div className="f-11">
                    { phone_number ? phone_number : "" }{phone_number ? <br /> : ""}
                    { email }
                </div>
            </TYItem>
        </div>;
    }
}

OperationsRecurrentDetailsContact.defaultProps = {
    data: {},
    recId: null
};

export default OperationsRecurrentDetailsContact;



// WEBPACK FOOTER //
// ./src/components/Operations/Recurrent/contact.js